import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  result: null,
  error: null,
};

const imageDescriptionSlice = createSlice({
  name: 'imageDescription',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setResult: (state, action) => {
      state.result = action.payload;
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.result = null;
    },
    reset: (state) => {
      state.loading = false;
      state.result = null;
      state.error = null;
    },
  },
});

export const {
  setLoading,
  setResult,
  setError,
  reset: resetImageDescription,
} = imageDescriptionSlice.actions;

export default imageDescriptionSlice.reducer;
